import directive from './directive';
export default function (app: any) {
    app.use(directive);
}
